import { CATEGORIES } from '@/core/config/categories';
import { categoryUrl } from '@/core/utils/category';

export const CATEGORY_KEYS = {
	cities: 'cities',
	comedy: 'comedy',
	music: 'music',
	ncaa: 'ncaa',
	other: 'other',
	shows: 'shows',
	sports: 'sports',
	theater: 'theater',
	venues: 'venues',
} as const;

export const CATEGORY_TITLES = {
	[CATEGORY_KEYS.cities]: 'Cities',
	[CATEGORY_KEYS.comedy]: 'Comedy',
	[CATEGORY_KEYS.music]: 'Music',
	[CATEGORY_KEYS.ncaa]: 'NCAA',
	[CATEGORY_KEYS.other]: 'Other',
	[CATEGORY_KEYS.shows]: 'Comedy & Theater',
	[CATEGORY_KEYS.sports]: 'Sports',
	[CATEGORY_KEYS.theater]: 'Theater',
	[CATEGORY_KEYS.venues]: 'Venues',
} as const;

export const CATEGORY_SLUGS_SHOWS = [
	CATEGORY_KEYS.comedy,
	CATEGORY_KEYS.theater,
] as const;

export const CATEGORY_SLUG_API_REF = [
	'mlb',
	'nba',
	'nfl',
	'nhl',
	'mls',
] as const;

export const CATEGORY_SLUGS_SPORTS = [
	...CATEGORY_SLUG_API_REF,
	'ncaa',
	CATEGORY_KEYS.other,
] as const;

export const CATEGORIES_NCAA = [
	{
		name: {
			full: 'CFB Bowl Games',
		},
		url: categoryUrl(CATEGORIES.bowl.slug),
	},
	{
		name: {
			full: 'College Basketball',
		},
		url: categoryUrl(CATEGORIES.cbb.slug),
	},
	{
		name: {
			full: 'College Baseball',
		},
		url: categoryUrl(CATEGORIES.cbs.slug),
	},
	{
		name: {
			full: 'College Football',
		},
		url: categoryUrl(CATEGORIES.cfb.slug),
	},
	{
		name: {
			full: 'College Hockey',
		},
		url: categoryUrl(CATEGORIES.cho.slug),
	},
	{
		name: {
			full: 'College Lacrosse',
		},
		url: categoryUrl(CATEGORIES.clax.slug),
	},
	{
		name: {
			full: "Women's College Basketball",
		},
		url: categoryUrl(CATEGORIES.wcbb.slug),
	},
] as const;

export const SELECTORS = Object.freeze({
	active: '.nav-active',
	button: '.js-nav-menu-toggle',
	headerNav: '.js-header-nav',
	listItem: '.js-nav-item',
	mainNav: '.js-main-nav',
	menu: '.js-nav-list',
	toggle: '.js-nav-toggle',
});
